export default [
    {
        name: 'characterModel',
        type: 'gltfModel',
        path: 'models/roblox_deadpool.glb'
    },
    {
        name: 'capModel',
        type: 'gltfModel',
        path: 'models/cap.glb'
    },
    {
        name: 'customuseIcon',
        type: 'texture',
        path: 'images/customuseIcon.png'
    }
]